export const qguidanceTransfer = (json) => {
  
  if (json.docs && json.docs.qs) {
    const qguidance = json.docs.qs;

    for (let i = 0; i < qguidance.length; i++) {
      for (let item in qguidance[i]) {
        if (item === 'value') {
          const qStr = qguidance[i][item];
          qguidance[i].str = qStr;
        } else {
          if (item !== 'str' && typeof qguidance[i][item] !== 'number') {
            const value = Number(qguidance[i][item]);
            qguidance[i][item] = value;
          }
        }
      }
    }
    return qguidance;

  } else {
    return [];
  }
}



// WEBPACK FOOTER //
// ./src/helpers/qguidanceTransfer.js